import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AppConfig from "../../../../../config/AppConfig";
import {AppIconThumbnail} from "../../../../../components/BaseComponents/AppIconThumbnail";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";

export default class TimeoffPaySlipListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleOpenPaySlip = _ => {
        if (this.props.onOpenPaySlip) {
            this.props.onOpenPaySlip(this.props.item);
        }
    }

    handleOpenPayCheck = _ => {
        if (this.props.onOpenPayCheck) {
            this.props.onOpenPayCheck(this.props.item);
        }
    }

    handleSignPaySlip = _ => {
        if (this.props.onSignPaySlip) {
            this.props.onSignPaySlip(this.props.item);
        }
    }

    hasPaySlipAttachment = item => parseInt(item?.pay_slip_attachment, 10) === 1;

    hasPayCheckAttachment = item => parseInt(item?.pay_check_attachment, 10) === 1;

    getStatusLabel = status => {
        switch (status) {
            case "undelivered":
                return {label: "Non consegnata", className: "badge badge-secondary"};
            case "delivered":
                return {label: "Consegnata", className: "badge badge-info"};
            case "signed":
                return {label: "Firmata digitalmente", className: "badge badge-success"};
            case "signed_manual":
                return {label: "Firmata", className: "badge badge-success"};
            default:
                return {label: "Non disponibile", className: "badge badge-light"};
        }
    }

    getPeriodLabel = item => {
        if (!item?.start_date || !item?.end_date) return "-";
        const startDate = moment(item.start_date);
        const endDate = moment(item.end_date);

        if (!startDate.isValid() || !endDate.isValid()) return "-";

        const sameMonth = startDate.isSame(endDate, "month");
        const isFullMonth = sameMonth && startDate.date() === 1 && endDate.date() === endDate.daysInMonth();

        if (isFullMonth) {
            return startDate.format("MMMM YYYY");
        }

        return `${startDate.format("DD/MM/YYYY")} - ${endDate.format("DD/MM/YYYY")}`;
    }

    render() {
        const item = this.props.item || {};
        const staff = this.props.staff || {};
        const negozio = staff.negozio || item.negozio || null;
        const negozioIconUrl = negozio?.id_negozio
            ? `${AppConfig.webServerUrl}/api/negozio/${negozio.id_negozio}/logoIcon/50`
            : null;
        const statusInfo = this.getStatusLabel(item.status);
        const periodLabel = this.getPeriodLabel(item);
        const showPaySlip = this.hasPaySlipAttachment(item);
        const showPayCheck = this.hasPayCheckAttachment(item);
        const statusValue = String(item.status || "").toLowerCase();
        const showSign = statusValue.indexOf("signed") !== 0;
        const showActions = showPaySlip || showPayCheck || showSign;

        return (
            <div className={"list-group-item"}>
                <div className={"d-flex justify-content-between align-items-start"}>
                    <div className={"d-flex align-items-center"}>
                        <AppIconThumbnail size={"32px"} src={negozioIconUrl} className={"mr-2"}/>
                        <div className={"font-weight-bold"}>{negozio?.nome || "Attivita'"}</div>
                    </div>
                </div>
                <div className={"text-muted mt-1"}>
                    Busta di {periodLabel} <span className={statusInfo.className}>{statusInfo.label}</span>
                </div>
                {
                    showActions &&
                    <div className={"mt-3 d-flex flex-wrap"}>
                        {
                            showPaySlip &&
                            <button
                                type={"button"}
                                className={"btn btn-outline-primary btn-sm mr-2 mb-2"}
                                onClick={this.handleOpenPaySlip}
                            >
                                <FaSolidIcon name={"eye"}/> Vedi busta
                            </button>
                        }
                        {
                            showPayCheck &&
                            <button
                                type={"button"}
                                className={"btn btn-soft-primary btn-sm mr-2 mb-2"}
                                onClick={this.handleOpenPayCheck}
                            >
                                <FaSolidIcon name={"file-invoice-dollar"}/>  Vedi bonifico
                            </button>
                        }
                        {
                            showSign &&
                            <button
                                type={"button"}
                                className={"btn btn-primary btn-sm mb-2"}
                                onClick={this.handleSignPaySlip}
                            >
                                <FaSolidIcon name={"file-signature"}/> Firma
                            </button>
                        }
                    </div>
                }
            </div>
        );
    }
}

TimeoffPaySlipListItem.propTypes = {
    item: PropTypes.object,
    staff: PropTypes.object,
    onOpenPaySlip: PropTypes.func,
    onOpenPayCheck: PropTypes.func,
    onSignPaySlip: PropTypes.func
};
